var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Sound",class:{ 'is-active': _vm.active },on:{"click":function($event){_vm.active = !_vm.active}}},[_c('div',{staticClass:"Sound__ico",domProps:{"innerHTML":_vm._s(require('./svg/ico.svg'))}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48e7460f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sound/Sound.vue
// module id = null
// module chunks = 